import { render } from "./phone.vue?vue&type=template&id=7952fdd8&scoped=true&ts=true"
import script from "./phone.vue?vue&type=script&lang=ts"
export * from "./phone.vue?vue&type=script&lang=ts"

import "./phone.vue?vue&type=style&index=0&id=7952fdd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7952fdd8"],['__file',"src/components/inputs/phone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7952fdd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7952fdd8', __exports__)) {
    api.reload('7952fdd8', __exports__)
  }
  
  module.hot.accept("./phone.vue?vue&type=template&id=7952fdd8&scoped=true&ts=true", () => {
    api.rerender('7952fdd8', render)
  })

}


export default __exports__